export default "__VITE_ASSET__BrDW3Pkj__"